import { Pipe, PipeTransform } from '@angular/core';
import { NumberTranslatePipe } from '@app/shared/pipes/number-translate.pipe';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'ratingRange',
})
export class RatingRangePipe implements PipeTransform {
  constructor(
    private numberTranslatePipe: NumberTranslatePipe,
    private translateService: TranslateService
  ) {}
  transform(min: number, max: number): string {
    if (min < 0 || max > 5 || min > max) {
      return this.translateService.instant('POSTS.INVALID_RATING_RANGE');
    }

    if (min === max) {
      return `<span class="notranslate">${this.numberTranslatePipe.transform(min)} </span> <span>${this.translateService.instant('POSTS.STARS')}</span>`;
    }

    if (min === 0 && max === 5) {
      return `<span>${this.translateService.instant('POSTS.ANY_RATING')}</span>`;
    }

    if (min === 0) {
      return `<span>Below</span> <span class="notranslate"> ${this.numberTranslatePipe.transform(max)} </span>  <span>${this.translateService.instant('POSTS.STARS')}</span>`;
    }

    if (max === 5) {
      return `<span class="notranslate">${this.numberTranslatePipe.transform(min)} </span><span>${this.translateService.instant('POSTS.STARS_AND_ABOVE')}</span>`;
    }

    return `<span class="notranslate">${this.numberTranslatePipe.transform(min)} </span> <span>${this.translateService.instant('POSTS.TO')}</span><span class="notranslate"> ${this.numberTranslatePipe.transform(max)} </span> <span>${this.translateService.instant('POSTS.STARS')}</span>`;
  }
}
